module.exports = __webpack_public_path__ + "img/阅读@2x.523c84bd.png";